module.exports = __webpack_public_path__ + "static/FontAwesome5_Brands-c6aef942e3668158ec29d4adcb2e768f.ttf";